import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { IGrowerItem } from '../../../../../../modules/API/Defaults/models/growers'
import { IProductsWithVarietyItem } from '../../../../../../modules/API/Defaults/models/compliteProducts'
import SearchIcon from '../../../../../../generic/icons/IconLib/SearchIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import { IRecommendationItem } from '../../../../../../modules/API/Recommendation/models/recomendationItem'
import CircleCheckbox from '../../../../../../generic/ui/check-box/CircleCheckbox'
import ProductImage from '../../../queries/TeudotDetails/Components/ProductImage'
import TitleSearchInput from './TitleSearchInput'
import { useDispatch } from 'react-redux'
import { Product } from '../../../../../../modules/API/Products/products'
import { Recommendation } from '../../../../../../modules/API/Recommendation/Recommendation'
import ControlButton from '../../../../../../generic/buttons/ControlButton'
import { useTranslation } from 'react-i18next'
import FancyButton from '../../../knisotLines/Components/FancyButton'
import { SalesBarChart } from '../../../../../../generic/Charts/SalesBarChart'
import { LOAD, LOAD_END } from '../../../../../../../store/actions/actionsTypes'
import { handleNotifications } from '../../../../../../generic/utils/handleNotifications'

type TProductWithSelection = IProductsWithVarietyItem & {
  SizeID: string
  GrowerName?: string
  GrowerID?: number
  // флаг для UI (чекбокс)
  isSelected: boolean
  // флаг, что товар уже есть у поставщика (на основе recommendedProducts)
  isRecommended: boolean
}

type Props = {
  growerList: IGrowerItem[]
  productWithVarietyList: IProductsWithVarietyItem[]
  selectedGrower: number
  setSelectedGrower: React.Dispatch<React.SetStateAction<number>>
  recommendedProducts: IRecommendationItem[]
}

const GrowerProductMain = ({
  growerList,
  productWithVarietyList,
  selectedGrower,
  setSelectedGrower,
  recommendedProducts
}: Props) => { 
  const dispatch = useDispatch()
  const { t } = useTranslation(['buttons'])
  const [isOpenProduct, setIsOpenProduct] = useState(growerList.length > 1 ? false : true)
  const [isOpenGrower, setIsOpenGrower] = useState(true)
  const [selectedProducts, setSelectedProducts] = useState<Record<string, boolean>>({})
  const [inputProduct, setInputProduct] = useState<string>('')
  const [inputGrower, setInputGrower] = useState<string>('')
  const selectedGrowerData = useMemo(() => {
    return growerList.find((grower) => grower.GrowerID === selectedGrower)
  }, [growerList, selectedGrower])

  const handleSelectGrower = (grower: number) => {
    setSelectedGrower(grower)
    setIsOpenProduct(true)
    setSelectedProducts({})
  }

  const handleSaveProducts = async () => {
    dispatch({type: LOAD})
    console.log(selectedProducts)
    const reccommendedMap = new Map<string, IRecommendationItem>()
    recommendedProducts.forEach((item) => {
      reccommendedMap.set(`${item.ProductID}-${item.VarietyID}`, item)
    })
    const editedRecList = productWithVarietyList.map((item) => {
      const key = `${item.ProductID}-${item.VarietyID}`
      const isSelected = selectedProducts[key] !== undefined
      const productData = reccommendedMap.get(`${item.ProductID}-${item.VarietyID}`)
      if(isSelected) {
        return {
          ...item,
          isSelected: selectedProducts[key],
          isRecommended: !!productData,
          SizeID: productData?.SizeID || '',
        }
      }
      return {
        ...item,
        isSelected: !!productData,
        isRecommended: !!productData,
        SizeID: productData?.SizeID || '',
      }
    })
    try {
      const postData = editedRecList.filter((item: any) => item.isSelected === true).map((item) => {
        return {
          ProductID: item.ProductID,
          VarietyID: item.VarietyID,
          SizeID: item.SizeID,
        }
      })
      
      await Recommendation.createGrowerArrayRecommendation({
        GrowerID: selectedGrower,
        Products: postData,
      })
      handleNotifications("הפריטים נשמרו בהצלחה", {type: "success"})
    } catch (error) {
      handleNotifications("אירעה שגיאה בעת שמירת הפריטים", {type: "error"})
      console.log(error)
    } finally {
      dispatch({type: LOAD_END})
    }
  }

  const renderProduct: TProductWithSelection[] = useMemo(() => {
    if (!productWithVarietyList || !selectedGrower) return []

    // filter
    const filteredProduct = productWithVarietyList.filter(product => {
      return `${product.ProductDesc?.trim()} ${product.VarietyDesc?.trim()}`.toLowerCase().includes(inputProduct.toLowerCase())
    })
    return filteredProduct
      .map<TProductWithSelection>((product) => {
        const { ProductID, VarietyID } = product
        const key = `${ProductID}-${VarietyID}`

        const productData = recommendedProducts.find(
          (item) => item.ProductID === ProductID && item.VarietyID === VarietyID
        )

        // базовый флаг: товар уже есть у поставщика (рекомендация)
        const isRecommended = !!productData

        // переопределение из локального состояния чекбокса
        const overrideSelected = selectedProducts[key]
        const isSelected =
          typeof overrideSelected === 'boolean'
            ? overrideSelected
            : isRecommended

        return {
          ...product,
          isSelected,
          isRecommended,
          SizeID: productData?.SizeID || '',
        }
      })
      // сортировка ТОЛЬКО по isRecommended,
      // чтобы клик по чекбоксу не менял порядок
      .sort((a, b) => {
        if (a.isRecommended === b.isRecommended) return 0
        return a.isRecommended ? -1 : 1
      })
  }, [
    productWithVarietyList, 
    recommendedProducts, 
    selectedGrower, 
    selectedProducts,
    inputProduct
  ])
 
  const handleToggleProductSelect = (product: TProductWithSelection) => {
    const key = `${product.ProductID}-${product.VarietyID}`

    setSelectedProducts((prevState) => {
      const current = prevState[key]
      const next =
        typeof current === 'boolean' ? !current : !product.isSelected

      return {
        ...prevState,
        [key]: next
      }
    })
  }
  const filteredGrowerList = useMemo(() => {
    if (!inputGrower.trim()) return growerList;
    return growerList.filter(grower => 
      grower.GrowerName?.toLowerCase().includes(inputGrower.toLowerCase())
    );
  }, [growerList, inputGrower]);
  const weeklySales = [
    { id: 'mon', date: 'Mon', value: 120 },
    { id: 'tue', date: 'Tue', value: 90 },
    { id: 'wed', date: 'Wed', value: 150 },
    { id: 'thu', date: 'Thu', value: 80 },
    { id: 'fri', date: 'Fri', value: 200 },
    { id: 'sat', date: 'Sat', value: 170 },
    { id: 'sun', date: 'Sun', value: 130 },
  ];
  const handleBarClick = (item: {id: string, date: string, value: number}) => {
    console.log(item)
  }
  return (
    <MainWrapper>
      {/* <SalesBarChart
        data={weeklySales}
        onBarClick={handleBarClick}
      /> */}
     <ResizbleProductWrapper
      $isOpen={isOpenProduct}
     >
      <TitlesWrapper>
        {
          isOpenProduct && (
            <TitleSearchInput
              value={inputProduct}
              onChange={setInputProduct}
              displayText={`פריטים למגדל: ( ${selectedGrowerData?.GrowerName?.trim() || ''} )`}
              icon={<SearchIcon />}
              placeholder="חפש פריט..."
            />
            
          )
        }
      </TitlesWrapper>
      <ScrolbleWrapper>
        {
          renderProduct.map((product) => (
            <Item 
              key={`${product.ProductID}-${product.VarietyID}`}
              
            >
              <SideWrapper>
                <ProductImage
                  id={product.GeneralProductID}
                />
              </SideWrapper>
              {product.ProductDesc?.trim()} {product.VarietyDesc?.trim()}
              <CircleCheckbox
                checked={product.isSelected}
                onChange={() => handleToggleProductSelect(product)}
              />
            </Item>
          ))
        }
      </ScrolbleWrapper>
      <FancyButton
        onClick={handleSaveProducts}
      >
        {t('save')}
      </FancyButton>
     </ResizbleProductWrapper>
     <ResizbleGrowerWrapper>
      <TitlesWrapper>
        <TitleSearchInput
          value={inputGrower}
          onChange={setInputGrower}
          displayText="בחר מגדל"
          icon={<SearchIcon />}
          placeholder="חפש מגדל..."
        />
      </TitlesWrapper>
      <ScrolbleWrapper>
        {
          filteredGrowerList.map((grower) => (
            <Item 
              key={grower.GrowerID} 
              onClick={() => handleSelectGrower(grower.GrowerID)}
              $isSelected={selectedGrower === grower.GrowerID}
            >
              {grower.GrowerName}
              <UserIcon />
            </Item>
          ))
        }
      </ScrolbleWrapper>
     </ResizbleGrowerWrapper>
    </MainWrapper>
  )
}

export default GrowerProductMain

const MainWrapper = styled.div`
  --primary-green: #297F76;
  --primary-green-dark: #1e8449;
  --bg-light: #f5f7fa;
  --bg-white: #ffffff;
  --text-primary: #1F1F1F;
  --shadow-light: rgba(0, 0, 0, 0.06);
  --shadow-green: rgba(41, 127, 118, 0.15);

  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  z-index: 1;
  background: #fdfdfd;
  border-radius: 30px;
  padding: 0.75em;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(41, 127, 118, 0.08);
`
const TitlesWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5em;
  padding: 0.75em 1em;
  font-weight: 600;
  font-size: 1.1em;
  color: var(--primary-green, #297F76);
  font-family: 'Assistant', sans-serif;
  line-height: 1;
`
const ResizbleGrowerWrapper = styled.div`
  min-width: 35%;
  height: 100%;
  display: flex;
  flex-flow: column;
  gap: 1em;
  padding: 0.75em;
  background: var(--bg-light, #f5f7fa);
  border-radius: 3px 25px 25px 3px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
`
const ResizbleProductWrapper = styled.div<{ $isOpen: boolean }>`
  width: ${props => props.$isOpen ? '100%' : '5%'};
  height: 100%;
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  flex-flow: column;
  align-items: center;
  gap: 1em;
  padding: 0.75em;
  background: var(--bg-light, #f5f7fa);
  transition: all 2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 25px 3px 3px 25px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
`
const ScrolbleWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  gap: 0.5em;
  padding: 0.75em 1em;
  background: var(--bg-white, #ffffff);
  border-radius: 12px;
  overflow-y: auto;
  box-shadow: 0 1px 3px var(--shadow-light, rgba(0, 0, 0, 0.06));
  &::-webkit-scrollbar {
    width: 0;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`

const Item = styled.div<{ $isSelected?: boolean }>`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5em;
  padding: 0.75em 1em;
  background: ${props => 
    props.$isSelected 
      ? 'linear-gradient(135deg, var(--primary-green, #297F76) 0%, var(--primary-green-dark, #1e8449) 100%)'
      : '#f8f9fa'
  };
  color: ${props => 
    props.$isSelected 
      ? '#ffffff'
      : '#6b7280'
  };
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${props => 
    props.$isSelected 
      ? '0 2px 6px rgba(41, 127, 118, 0.2)'
      : '0 1px 3px rgba(0, 0, 0, 0.1)'
  };
  
  &:hover {
    background: ${props => 
      props.$isSelected 
        ? 'rgba(41, 127, 118, 0.9)'
        : '#e8f5e9'
    };
    color: ${props => 
      props.$isSelected 
        ? '#ffffff'
        : '#4b5563'
    };
    box-shadow: ${props => 
      props.$isSelected 
        ? '0 3px 8px rgba(41, 127, 118, 0.3)'
        : '0 2px 4px var(--shadow-green, rgba(41, 127, 118, 0.15))'
    };
  }
`

const SideWrapper = styled.div`
  position: absolute;
  top: calc(50% - 1.5em);
  left: 0.5em;
  max-width: 3em;
  max-height: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
  padding: 0.25em;

  /* filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.1)); */
  -webkit-filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.1));
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.1));
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
`